import clsx from 'clsx';
import React from 'react';
import {
  STATUS_KIND_STYLES,
  FINAL_STATUS_STYLES,
  DEFAULT_STATUS_STYLE,
} from '../utils/statusStyles';

type StatusCategory =
  | 'DRAFT'
  | 'NEW'
  | 'RESUBMIT'
  | 'IP'
  | 'LOCKED'
  | 'CMPLT'
  | 'CLOSED'
  | 'ERROR'
  | string;

interface StatusPillProps {
  status: string;
  category?: StatusCategory;
  className?: string;
  text?: string;
  small?: boolean;
}

export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  category,
  className,
  text,
  small,
}) => {
  // D: Draft; I: Initial; T: Transitory; F: Final
  const categoryKinds: Record<string, 'D' | 'I' | 'T' | 'F'> = {
    DRAFT: 'D',
    NEW: 'I',
    RESUBMIT: 'I',
    IP: 'T',
    LOCKED: 'T',
    HOLD: 'T',
    CMPLT: 'F',
    CLOSED: 'F',
    ERROR: 'F',
  };

  const categoryKey = category?.toUpperCase() || '';
  const kind = categoryKinds[categoryKey];

  const statusClass =
    (kind === 'F' && FINAL_STATUS_STYLES[categoryKey]) ||
    (kind && STATUS_KIND_STYLES[kind]) ||
    DEFAULT_STATUS_STYLE;

  return (
    <span
      className={clsx(
        'tw:rounded-full tw:border tw:text-center',
        small
          ? 'tw:text-[10px]/4 tw:px-[calc(theme(spacing[1.5])-1px)] tw:py-[1px]'
          : 'tw:text-xs tw:px-2 tw:py-1',
        statusClass,
        className
      )}
    >
      {text || status}
    </span>
  );
};

export default StatusPill;
